(function () {

	'use strict';
	angular
		.module('AutoPrequal')
		.service('GoogleInitializer', ['$q', '$rootScope', '$window', function ($q, $rootScope, $window) {
			'use strict';

			var urlBase = "https://maps.googleapis.com/maps/api/js?libraries=places&callback=googleMapsInitialized";
			var deferred = null;
			return {
				getReadyPromise: function () {
					if ($window.google != undefined && $window.google.maps) return $q.resolve();
					if (deferred) return deferred.promise;
					deferred = $q.defer();
					$window.googleMapsInitialized = function () {
						deferred.resolve("googleMaps loaded");
						deferred = null;
					};
					var config = $rootScope.glConfig;
					var lang;
					if (window.locale === 'fr') {
						lang = "&language=fr-CA";
					} else {
						lang = "&language=en";
					}

					var script = document.createElement('script');
					script.type = 'text/javascript';
					script.src = urlBase + "&client=gme-cment" + lang;
					document.body.appendChild(script);
					return deferred.promise;
				}
			}
		}]);
})();
